import { type Images } from '@neos/app'
import accountPath from '../../modules/Components/images/Account.svg'
import bladePath from '../../modules/Components/images/Blade.svg'
import canisterPath from '../../modules/Components/images/Canister.svg'
import cartPath from '../../modules/Components/images/Cart.svg'
import darkThemePath from '../../modules/Components/images/DarkTheme.svg'
import dialogTemplatePath from '../../modules/Components/images/DialogTemplate.svg'
import dropPath from '../../modules/Components/images/Drop.svg'
import entityPath from '../../modules/Components/images/Entity.svg'
import filterPath from '../../modules/Components/images/Filter.svg'
import fitDemoPath from '../../modules/Components/images/FitDemo.svg'
import fitDemoMaskPath from '../../modules/Components/images/FitDemoMask.svg'
import gaugePath from '../../modules/Components/images/Gauge.svg'
import grainPath from '../../modules/Components/images/Grain.svg'
import heartPath from '../../modules/Components/images/Heart.svg'
import helpBubblePath from '../../modules/Components/images/HelpBubble.svg'
import islandPath from '../../modules/Components/images/Island.svg'
import islandNightPath from '../../modules/Components/images/IslandNight.svg'
import lightThemePath from '../../modules/Components/images/LightTheme.svg'
import lookupPath from '../../modules/Components/images/Lookup.svg'
import packagePath from '../../modules/Components/images/Package.svg'
import playPath from '../../modules/Components/images/Play.svg'
import postPath from '../../modules/Components/images/Post.svg'
import progressFillPath from '../../modules/Components/images/ProgressFill.svg'
import progressThresholdPath from '../../modules/Components/images/ProgressThreshold.svg'
import shieldPath from '../../modules/Components/images/Shield.svg'
import stopPath from '../../modules/Components/images/Stop.svg'
import textboxPath from '../../modules/Components/images/Textbox.svg'

const images: Images = {
  account: { path: accountPath, colored: false },
  blade: { path: bladePath, colored: false },
  canister: { path: canisterPath, colored: false },
  cart: { path: cartPath, colored: false },
  darkTheme: { path: darkThemePath, colored: false },
  dialogTemplate: { path: dialogTemplatePath, colored: false },
  drop: { path: dropPath, colored: false },
  edit: 'edit',
  entity: { path: entityPath, colored: true },
  filter: { path: filterPath, colored: false },
  fitDemo: { path: fitDemoPath, colored: true },
  fitDemoMask: { path: fitDemoMaskPath, colored: false },
  gauge: { path: gaugePath, colored: false },
  grain: { path: grainPath, colored: false },
  heart: { path: heartPath, colored: false },
  helpBubble: { path: helpBubblePath, colored: false },
  island: { path: islandPath, colored: true },
  islandNight: { path: islandNightPath, colored: true },
  lightTheme: { path: lightThemePath, colored: false },
  lookup: { path: lookupPath, colored: true },
  menu: 'menu',
  orderReset: 'reset',
  orderValidate: 'validate',
  package: { path: packagePath, colored: false },
  play: { path: playPath, colored: true },
  post: { path: postPath, colored: false },
  print: 'print',
  progressFill: { path: progressFillPath, colored: true },
  progressThreshold: { path: progressThresholdPath, colored: true },
  remove: 'remove',
  send: 'send',
  shield: { path: shieldPath, colored: false },
  stop: { path: stopPath, colored: true },
  textbox: { path: textboxPath, colored: false },
}

export default images